import CustomerFeedbackTable from "../../components/customer-feedback";
import HeaderPage from "../../components/lines-managements/header/HeaderPage";

// List page for the BD/ops Customer Feedback queue. The HeaderPage
// wrapper renders without its default search (the route search lives
// inside the filter bar so it sits next to the other filters). All
// filters live inside the table component so they have direct access
// to the URL search params driving the list query.
const CustomerFeedbackPage: React.FC = () => {
  return (
    <>
      <HeaderPage hasNoInput />
      <CustomerFeedbackTable />
    </>
  );
};

export default CustomerFeedbackPage;
